const CHANGE_FOLDER_NAME = 'menu/CHANGE-FOLDER-NAME';
const SERVICE_DATA_TO_MENU = 'menu/SERVICE-DATA-TO-MENU';
const SERVICE_LIST_TO_MENU = 'menu/SERVICE-LIST-TO-MENU';
const SERVICE_BULK_TO_MENU = 'menu/SERVICE-BULK-TO-MENU';
const SERVICE_DATA_TO_FOLDER = 'menu/SERVICE-DATA-TO-FOLDER';
const SERVICE_LIST_TO_FOLDER = 'menu/SERVICE-LIST-TO-FOLDER';
const DELETE_MENU_ITEM = 'menu/DELETE-MENU-ITEM';

export default {
  CHANGE_FOLDER_NAME,
  SERVICE_DATA_TO_MENU,
  SERVICE_LIST_TO_MENU,
  SERVICE_BULK_TO_MENU,
  SERVICE_DATA_TO_FOLDER,
  SERVICE_LIST_TO_FOLDER,
  DELETE_MENU_ITEM,
};
